let sumNum, num1, num2;
let numberOfTries = 0;
let resultNumArr = [];
function generateRandomNum(getIndex) {

    num1 = Math.round(Math.random() * (8)) + 1;
    num2 = Math.round(Math.random() * (8)) + 1;
    // sumNum = num1 + num2;

    if (typeof getIndex !== 'undefined') {
        resultNumArr[getIndex] = num1 + num2;
    }
    else {
        resultNumArr.push(num1 + num2);
    }

}

/**
 * @param {Object}
 * @param {Object}
 * @param {Boolean}
*/
function setCaptcha($el, options, shouldReset) {

    if (!shouldReset) {

        $el.insertAdjacentHTML('beforebegin',
            `<canvas class="${options.canvasClass}"
                    width="${options.canvasStyle.width}" height="${options.canvasStyle.height}">
                </canvas>
            `);

        this.$captchaEl = document.querySelector(`.${options.canvasClass}`);
        this.$captchaTextContext = this.$captchaEl.getContext('2d');

    }
    else {
        // get the current options.canvasClass
        this.$captchaEl = $el.previousElementSibling;

    }
    this.$captchaTextContext = this.$captchaEl.getContext('2d');
    this.$captchaTextContext = Object.assign(this.$captchaTextContext, options.canvasStyle);
    this.$captchaTextContext.clearRect(0, 0, options.canvasStyle.width, options.canvasStyle.height);
    this.$captchaTextContext.fillText(`${num1} + ${num2} ${options.requiredValue}`, 0, 0);

}

/**
 * @param {Object}
*/
function jCaptcha(options = {}) {

    this.options = Object.assign({}, {
        el: 'jCaptcha',
        canvasClass: 'jCaptchaCanvas',
        requiredValue: '*',
        resetOnError: true,
        focusOnError: true,
        clearOnSubmit: true,
        callback: null,
        canvasStyle: {
        }
    }, options);

    this._init();


};

jCaptcha.prototype = {

    _init() {
        // console.log('this.options:', this.options);
        this.$el = document.querySelector(this.options.el);
        generateRandomNum();
        setCaptcha.call(this, this.$el, this.options);
    },

    validate(event) {
        // console.log('this', this);
        let _thisEl = event.target.querySelector('.jCaptcha');
        let getIndex = _thisEl.id.split('-')[1];
        let getAnswer = resultNumArr[getIndex];

        numberOfTries++;

        this.callbackReceived = this.callbackReceived || (typeof this.options.callback == 'function');

        // console.log('input: ', this.$el);
        if (_thisEl.value != getAnswer) {
            // console.log('correct');

            this.callbackReceived && this.options.callback('error', _thisEl, numberOfTries, event);

            (this.options.resetOnError === true) && this.reset(event);
            (this.options.focusOnError === true) && _thisEl.focus();
            (this.options.clearOnSubmit === true) && (getAnswer = '');

        } else {

            this.callbackReceived && this.options.callback('success', _thisEl, numberOfTries, event);
            (this.options.clearOnSubmit === true) && (getAnswer = '');
        }
    },

    reset(event) {
        // console.log('this', this);
        let _thisEl = event.target.querySelector('.jCaptcha');
        let getIndex = _thisEl.id.split('-')[1];
        generateRandomNum(getIndex);

        setCaptcha.call(this, _thisEl, this.options, true);
    }
};


export { jCaptcha }